(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('CongesDeleteController',CongesDeleteController);

    CongesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Conges'];

    function CongesDeleteController($uibModalInstance, entity, Conges) {
        var vm = this;

        vm.conges = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Conges.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
